import type { VKCue } from 'vendors/videokit'
import store from './store'

export const subtitles = store<{ [key: string]: VKCue[][] }>({})
